import { WorkspacesListWidget } from '@control-front-end/app/src/components/Menu/components/Workspace/Workspace';
import ValencySelectorNodeMenu from './ValencySelectorNodeMenu';

import { NODE_WIDGET } from '../constants';

export default {
  [NODE_WIDGET.workspaceSelector]: WorkspacesListWidget,
  [NODE_WIDGET.valencySelector]: ValencySelectorNodeMenu,
};
